{
  "gain": 1,
  "pan": 0,
  "fx_EQ_isActive": false,
  "fx_EQ_low": 0,
  "fx_EQ_mid": 0,
  "fx_EQ_high": 0,
  "send_reverbA": -60,
  "send_reverbB": -60,
  "send_delayA": -60,
  "send_delayB": -60,
  "env_attack": 1.964,
  "env_decay": 1.1300000000000008,
  "env_sustain": 0.8,
  "env_release": 2,
  "osc_waveform": "sawtooth",
  "lpf_cutoff": 1744.9503338234701,
  "lpf_q": 0.7,
  "lfo_rate": 1.0135939871692217,
  "lfo_depth": 209.9999999999996,
  "osc_octave": 0,
  "fx_distortion_amount": 1.800000000000001,
  "_metadata": {
    "instrumentType": "synth_wam"
  }
}